import api from './api';

// Upload single image
export const uploadImage = async (file, token) => {
    try {
        const formData = new FormData();
        formData.append('image', file);

        const response = await api.post('/upload/image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading image:', error);
        throw error;
    }
};

// Upload multiple images
export const uploadImages = async (files, token) => {
    try {
        const formData = new FormData();
        files.forEach(file => {
            formData.append('images', file);
        });

        const response = await api.post('/upload/images', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading images:', error);
        throw error;
    }
};

